<template>
  <b-card>

    <b-form class="m-2">
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Número" label-for="number">
            <b-form-input id="number" v-model="teams.number" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Nombre" label-for="name">
            <b-form-input id="name" v-model="teams.name" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Encargado" label-for="manager">
            <b-form-input id="manager" v-model="teams.manager" trim></b-form-input>
            </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <div>
      <b-button type="submit" class="m-1" variant="primarySpore" @click="save()">Guardar</b-button>
      <b-button type="reset" class="m-1" variant="outline-danger" @click="cancel()">Cancelar</b-button>
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */

import {
  BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput
} from 'bootstrap-vue'

import request from '@/libs/request/index'
import { app } from '@/main'

export default {
  components: {
    BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput
  },
  data () {
    return {
      teams: {
        number: '',
        name: '',
        manager: ''
      }
    }
  },
  methods: {
    cancel () {
      this.teams.number = ''
      this.teams.name = ''
      this.teams.manager = ''
      app.$router.push('/teams')
    },
    async save () {
      const params = {
        url: '/teams',
        method: 'POST',
        params: this.teams
      }
      await request(params).then(data => {
        app.$router.push('/teams')
      })
    }
  },
  created () {

  }
}
</script>
